import {
  add2suhfggl4zvkk as add,
  negate13xrbakfwasjy as negate,
  multiply2k9eolhnz1bjv as multiply,
  dividelr0uqtdj497z as divide,
  fromInt2ii0rejb1w62w as fromInt,
  convertToInty04h231mmjoh as convertToInt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import { ArithmeticException18dajwq7kbp38 as ArithmeticException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function safeAdd(a, b) {
  var sum = add(a, b);
  if ((a ^ sum) < 0n && (a ^ b) >= 0n) {
    throw ArithmeticException().oe('Addition overflows a long: ' + a.toString() + ' + ' + b.toString());
  }
  return sum;
}
function safeMultiply(a, b) {
  if (b === -1n) {
    if (a === -9223372036854775808n) {
      throw ArithmeticException().oe('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
    }
    return negate(a);
  } else if (b === 0n)
    return 0n;
  else if (b === 1n)
    return a;
  var total = multiply(a, b);
  if (!(divide(total, b) === a)) {
    throw ArithmeticException().oe('Multiplication overflows a long: ' + a.toString() + ' * ' + b.toString());
  }
  return total;
}
function safeMultiply_0(a, b) {
  // Inline function 'kotlin.Long.times' call
  var this_0 = fromInt(a);
  var result = multiply(this_0, fromInt(b));
  if (result > 2147483647n || result < -2147483648n)
    throw ArithmeticException().oe('Multiplication overflows Int range: ' + a + ' * ' + b + '.');
  return convertToInt(result);
}
//region block: exports
export {
  safeAdd as safeAdd2ojtf0puot5k0,
  safeMultiply as safeMultiply1xb0xo3cufzd3,
  safeMultiply_0 as safeMultiplyomi65rg5l1en,
};
//endregion

//# sourceMappingURL=mathJs.mjs.map
